// extracted by mini-css-extract-plugin
module.exports = {"content_left_description":"ModalTextDescription_content_left_description__9wWc0"};